// extracted by mini-css-extract-plugin
export default {"subtopicHeader":"TopicPosts-module__subtopicHeader--WU+EY","isEditing":"TopicPosts-module__isEditing--n-Z7L","animatedBackground":"TopicPosts-module__animatedBackground---qKja"};